import { useMutation } from '@tanstack/react-query';

import type { ContactCandidateData } from '../useContactCandidateMutation.types';

import { encodeBase64 } from 'helpers/base64';
import { useBrowserExtension } from 'shared/legacy/hooks/useBrowserExtension/useBrowserExtension';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';
import { extractEsPersonId } from '../utils/extractEsPersonId';

export const useContactLinkedinInMailMutation = () => {
  const { sendLinkedinProMessage, existsLinkedinInmailConversationWithCandidate } = useBrowserExtension();
  const { data: currentUser } = useCurrentUserQuery();

  return useMutation(async (params: ContactCandidateData<'linkedin_inmail'>) => {
    if (!currentUser) {
      throw new Error('Current user not found');
    }

    const { esPersonId, message, subject } = params;
    const esPersonIdWithoutPlatform = extractEsPersonId(esPersonId);

    const threadId = await existsLinkedinInmailConversationWithCandidate(esPersonIdWithoutPlatform);

    await sendLinkedinProMessage({
      candidate_id: esPersonIdWithoutPlatform,
      subject,
      body: message,
      signature: currentUser.mailSignOff.fullName,
      mailThread: threadId,
    });

    return { thread_id: encodeBase64(`${currentUser?.id}-${esPersonId}`) };
  });
};
